import { Underline as UnderlineExtension } from '@tiptap/extension-underline';

export const Underline = UnderlineExtension.extend({
  parseHTML() {
    const parentConfig = this.parent?.() ?? [];
    return [
      ...parentConfig,
      {
        // For lesson-conversion, used in classic editor
        style: 'text-decoration-line',
        consuming: false,
        getAttrs: (value) => value.toString().includes('underline') && null,
      },
    ];
  },
});
